import React, { useContext, useEffect, useState } from 'react'
import { useForm, useRequestGet } from '../../Hooks'
import { StoreContextMain } from '../../Context/StoreContextMain'

export const Filters = () => {

    const { filtersContext, setFilterContext } = useContext(StoreContextMain)

    const [selectedValues, setSelectedValues] = useState({});
    const [filters, setFilters] = useState(null)
    const [enableUpdate, setEnableUpdate] = useState(false)

    const {data} = useRequestGet('category')

    const { formState, onInputChange, onResetForm } = useForm({})

    useEffect(() => {
        if (data) {
            setFilters( JSON.parse(data) )
        }
    }, [data])

    useEffect(() => {
        console.log('formState ', formState);
        setFilterContext(formState)
    }, [formState, setFilterContext, enableUpdate])

    const handleCheckValue = (e) => {
        const {name, checked, value} = e.target;
        setSelectedValues((prev) => ({
            ...prev,
            [name]:checked
        }) )

        console.log(name, checked, value)

        if (checked) {
            onInputChange(e)
            setEnableUpdate(false)
        } else {
            delete formState[name]
            console.log(formState)
            setEnableUpdate(true)
        }
    }

    return (
        <div className='d-flex flex-column w-100 m-auto' style={{ overflowY: 'auto', overflowX: 'hidden' }}>
            {
                filters?.map((item, index) => {

                    if (item?.category_item?.length <= 0 || item?.category_item === null) {
                        return null
                    }

                    return (
                        <form key={index}>
                            <h5> {item.name} </h5>
                            <ul>
                            {
                                item?.category_item?.map((sub, index) => (
                                    <label key={index} className='form-check form-check-inline'>
                                        <input 
                                            className='form-check-input' 
                                            type='checkbox' 
                                            name={sub.name} 
                                            value={sub.uuid} 
                                            checked={selectedValues[sub.name] || false}
                                            onChange={handleCheckValue}    
                                        />
                                        <span className='form-check-label'> {sub.name} </span>
                                    </label>
                                ))
                            }
                            </ul>
                        </form>
                    )
                })
            }
        </div>
    )
}
